// This file is autogenerated by tools/genMaterialLibrary. DO NOT EDIT IT DIRECTLY.
export const LayerConfigIdToJson = [
  "/static/materials/layerconfigs/Carpet_Texture_Oatmeal.layers.json",
  "/static/materials/layerconfigs/Carpet_Texture_Rawwood.layers.json",
  "/static/materials/layerconfigs/RoofTEMP_Black.layers.json",
  "/static/materials/layerconfigs/GAF_Charcoal.layers.json",
  "/static/materials/layerconfigs/GAF_WeatheredWood.layers.json",
  "/static/materials/layerconfigs/RoofTEMP_Gray.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_CharcoalBlack.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Driftwood.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_GeorgetownGray.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_HeatherBlend.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_MoireBlack.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_WeatheredWood.layers.json",
  "/static/materials/layerconfigs/RoofTEMP_ResawnShake.layers.json",
  "/static/materials/layerconfigs/Roof_StandingSeamIR_CharcoalGray.layers.json",
  "/static/materials/layerconfigs/Roof_StandingSeamIR_CoalBlack.layers.json",
  "/static/materials/layerconfigs/Atlas_WeatheredWood.layers.json",
  "/static/materials/layerconfigs/RoofTEMP_Black.layers.json",
  "/static/materials/layerconfigs/GAF_Charcoal.layers.json",
  "/static/materials/layerconfigs/GAF_WeatheredWood.layers.json",
  "/static/materials/layerconfigs/RoofTEMP_Gray.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_CharcoalBlack.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Driftwood.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_GeorgetownGray.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_HeatherBlend.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_MoireBlack.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_WeatheredWood.layers.json",
  "/static/materials/layerconfigs/RoofTEMP_ResawnShake.layers.json",
  "/static/materials/layerconfigs/Roof_StandingSeamIR_CharcoalGray.layers.json",
  "/static/materials/layerconfigs/Roof_StandingSeamIR_CoalBlack.layers.json",
  "/static/materials/layerconfigs/NULL.layers.json",
  "/static/materials/layerconfigs/NULL.layers.json",
  "/static/materials/layerconfigs/NULL.layers.json",
  "/static/materials/layerconfigs/NULL.layers.json",
  "/static/materials/layerconfigs/NULL.layers.json",
  "/static/materials/layerconfigs/Wood_Brown.layers.json",
  "/static/materials/layerconfigs/Wood_Cedar.layers.json",
  "/static/materials/layerconfigs/Wood_Morado.layers.json",
  "/static/materials/layerconfigs/Wood_NaturallyDistressedCharcoal.layers.json",
  "/static/materials/layerconfigs/Wood_NaturallyDistressedWhite.layers.json",
  "/static/materials/layerconfigs/Wood_Oak.layers.json",
  "/static/materials/layerconfigs/Brick_FAKE_Chalk.layers.json",
  "/static/materials/layerconfigs/Brick_SW_7068_GrizzleGray.layers.json",
  "/static/materials/layerconfigs/Brick_Tri_BessemerGray.layers.json",
  "/static/materials/layerconfigs/Brick_Tri_Oxford.layers.json",
  "/static/materials/layerconfigs/Brick_Tri_SouthHampton.layers.json",
  "/static/materials/layerconfigs/Brick_Mer_SaltPlains.layers.json",
  "/static/materials/layerconfigs/Brick_Mer_ShadowFalls.layers.json",
  "/static/materials/layerconfigs/Brick_Mer_SummerAsh.layers.json",
  "/static/materials/layerconfigs/Brick_Che_Augusta.layers.json",
  "/static/materials/layerconfigs/Brick_Che_Natchez.layers.json",
  "/static/materials/layerconfigs/Brick_Mer_AlpineSelect.layers.json",
  "/static/materials/layerconfigs/Brick_Tri_EvelynBay.layers.json",
  "/static/materials/layerconfigs/Brick_Tri_MountainBranchSelect.layers.json",
  "/static/materials/layerconfigs/HorizontalBoard_Nichia_Cedar.layers.json",
  "/static/materials/layerconfigs/HorizontalBoard_TimberBlend.layers.json",
  "/static/materials/layerconfigs/HorizontalBoard_White.layers.json",
  "/static/materials/layerconfigs/ShakeShingle_Foundry_034_Eggshell.layers.json",
  "/static/materials/layerconfigs/ShakeShingle_Foundry_112_Moss.layers.json",
  "/static/materials/layerconfigs/ShakeShingle_Gray.layers.json",
  "/static/materials/layerconfigs/ShakeShingle_JH_AgedPewter.layers.json",
  "/static/materials/layerconfigs/ShakeShingle_JH_BoothbayBlue.layers.json",
  "/static/materials/layerconfigs/ShakeShingle_JH_TimberBark.layers.json",
  "/static/materials/layerconfigs/ShakeShingle_SW_7047_Porpoise.layers.json",
  "/static/materials/layerconfigs/ShakeShingle_SW_7068_GrizzleGray.layers.json",
  "/static/materials/layerconfigs/ShakeShingle_SW_9126_HonedSoapstone.layers.json",
  "/static/materials/layerconfigs/ShakeShingle_White.layers.json",
  "/static/materials/layerconfigs/Masonry_Stone_Centurion_Hackett_Tulsa_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Hackett_Tulsa.layers.json",
  "/static/materials/layerconfigs/Stone_Premier_Stack_Walnut.layers.json",
  "/static/materials/layerconfigs/Masonry_Stone_Prostone_Sawgrass_Trim.layers.json",
  "/static/materials/layerconfigs/Masonry_Stone_Vener_Cobblestone_GreyBlend_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Vener_Cobblestone_GreyBlend.layers.json",
  "/static/materials/layerconfigs/Masonry_Stone_Vener_Cobblestone_Lonestar_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Vener_Cobblestone_Lonestar.layers.json",
  "/static/materials/layerconfigs/VerticalBoard_NaturallyDistressedCharcoal.layers.json",
  "/static/materials/layerconfigs/VerticalBoard_NaturallyDistressedWhite.layers.json",
  "/static/materials/layerconfigs/VerticalBoard_BM_936_MeadowMist.layers.json",
  "/static/materials/layerconfigs/VerticalBoard_Nichia_Cedar.layers.json",
  "/static/materials/layerconfigs/HorizontalPlank_Morado.layers.json",
  "/static/materials/layerconfigs/HorizontalPlank_Oyster.layers.json",
  "/static/materials/layerconfigs/HorizontalPlank_SlateGray.layers.json",
  "/static/materials/layerconfigs/StaggeredPlank_Cherry.layers.json",
  "/static/materials/layerconfigs/StaggeredPlank_Gunstock.layers.json",
  "/static/materials/layerconfigs/StaggeredPlank_Tower.layers.json",
  "/static/materials/layerconfigs/VerticalBoard_Thermory_Ignite.layers.json",
  "/static/materials/layerconfigs/HorizontalBoard_Thermory_Ignite.layers.json",
  "/static/materials/layerconfigs/VerticalBoard_Thermory_Ignite.layers.json",
  "/static/materials/layerconfigs/NULL.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_GeorgetownGray_MaxDef.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_WeatheredWood_MaxDef.layers.json",
  "/static/materials/layerconfigs/Brick_Mer_Alamo.layers.json",
  "/static/materials/layerconfigs/Brick_Mer_Belhaven.layers.json",
  "/static/materials/layerconfigs/Brick_Mer_Laredo.layers.json",
  "/static/materials/layerconfigs/Brick_Mer_MtRushmore.layers.json",
  "/static/materials/layerconfigs/Brick_Mer_NorthHighland.layers.json",
  "/static/materials/layerconfigs/Brick_Mer_OldGuignard.layers.json",
  "/static/materials/layerconfigs/Brick_Mer_OldJackson.layers.json",
  "/static/materials/layerconfigs/Brick_Mer_Smithsonian.layers.json",
  "/static/materials/layerconfigs/Brick_Mer_StLorain.layers.json",
  "/static/materials/layerconfigs/Brick_Mer_Baytown.layers.json",
  "/static/materials/layerconfigs/Brick_Mer_Dover.layers.json",
  "/static/materials/layerconfigs/Brick_Mer_StAndrews.layers.json",
  "/static/materials/layerconfigs/VinylStone_NaturalSlate.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3540_MountainAsh_V.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3540_MountainAsh.layers.json",
  "/static/materials/layerconfigs/Brick_Tri_OldColony.layers.json",
  "/static/materials/layerconfigs/Brick_Tri_Northampton.layers.json",
  "/static/materials/layerconfigs/Brick_CdS_FullBrown.layers.json",
  "/static/materials/layerconfigs/Stone_Env_Dakota.layers.json",
  "/static/materials/layerconfigs/Stone_SW_CustomEpcon.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_Summit.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_BlueRidge.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_Flintridge.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_Frost.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_Slate.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_BlueRidge_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_Flintridge_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_Frost_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_Slate_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_Summit_Trim.layers.json",
  "/static/materials/layerconfigs/GAF_BlackWalnut.layers.json",
  "/static/materials/layerconfigs/Tamko_NaturalTimber.layers.json",
  "/static/materials/layerconfigs/Tamko_OldeEnglishPewter.layers.json",
  "/static/materials/layerconfigs/Tamko_ThunderstormGrey.layers.json",
  "/static/materials/layerconfigs/Stone_CS_BucksCounty_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Cultured_BucksCounty.layers.json",
  "/static/materials/layerconfigs/Stone_CS_Chardonnay_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Cultured_Chardonnay.layers.json",
  "/static/materials/layerconfigs/Stone_Env_Dakota_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Env_EpconCustom_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Env_PASierra_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Env_PASierra.layers.json",
  "/static/materials/layerconfigs/Stone_Env_Dakota_CustomIN_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_SW_CustomINDakota.layers.json",
  "/static/materials/layerconfigs/Brick_SW_6246_NorthStar.layers.json",
  "/static/materials/layerconfigs/Brick_SW_9171_FeltedWool.layers.json",
  "/static/materials/layerconfigs/Brick_SW_9174_MothWing.layers.json",
  "/static/materials/layerconfigs/CT_Belmont_BlackGranite.layers.json",
  "/static/materials/layerconfigs/CT_Belmont_ColonialSlate.layers.json",
  "/static/materials/layerconfigs/CT_Belmont_GatehouseSlate.layers.json",
  "/static/materials/layerconfigs/CT_Belmont_Shenandoah.layers.json",
  "/static/materials/layerconfigs/CT_Belmont_StonegateGray.layers.json",
  "/static/materials/layerconfigs/CT_Belmont_WeatheredWood.layers.json",
  "/static/materials/layerconfigs/CT_CarriageHouse_BlackPearl.layers.json",
  "/static/materials/layerconfigs/CT_CarriageHouse_Brownstone.layers.json",
  "/static/materials/layerconfigs/CT_CarriageHouse_ColonialSlate.layers.json",
  "/static/materials/layerconfigs/CT_CarriageHouse_GatehouseSlate.layers.json",
  "/static/materials/layerconfigs/CT_CarriageHouse_GeorgianBrick.layers.json",
  "/static/materials/layerconfigs/CT_CarriageHouse_SherwoodForest.layers.json",
  "/static/materials/layerconfigs/CT_CarriageHouse_StonegateGray.layers.json",
  "/static/materials/layerconfigs/CT_CarriageHouse_VictorianBlue.layers.json",
  "/static/materials/layerconfigs/CT_GrandManor_BlackPearl.layers.json",
  "/static/materials/layerconfigs/CT_GrandManor_Brownstone.layers.json",
  "/static/materials/layerconfigs/CT_GrandManor_ColonialSlate.layers.json",
  "/static/materials/layerconfigs/CT_GrandManor_GatehouseSlate.layers.json",
  "/static/materials/layerconfigs/CT_GrandManor_GeorgianBrick.layers.json",
  "/static/materials/layerconfigs/CT_GrandManor_SherwoodForest.layers.json",
  "/static/materials/layerconfigs/CT_GrandManor_StonegateGray.layers.json",
  "/static/materials/layerconfigs/CT_GrandManor_WeatheredWood.layers.json",
  "/static/materials/layerconfigs/CT_HighlandSlate_BlackGranite.layers.json",
  "/static/materials/layerconfigs/CT_HighlandSlate_Fieldstone.layers.json",
  "/static/materials/layerconfigs/CT_HighlandSlate_MaxDef_WeatheredWood.layers.json",
  "/static/materials/layerconfigs/CT_HighlandSlate_NewEnglandSlate.layers.json",
  "/static/materials/layerconfigs/CT_HighlandSlate_SmokeyQuartz.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Premium_MaxDef_BurntSienna.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Premium_MaxDef_ColonialSlate.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Premium_MaxDef_Driftwood.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Premium_MaxDef_GeorgetownGray.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Premium_MaxDef_HeatherBlend.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Premium_MaxDef_MoireBlack.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Premium_MaxDef_PewterWood.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Premium_MaxDef_ResawnShake.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Premium_MaxDef_WeatheredWood.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Pro_CinderBlack.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Pro_GraniteGray.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Pro_MaxDef_BlackWalnut.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Pro_MaxDef_BurntSienna.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Pro_MaxDef_CharcoalBlack.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Pro_MaxDef_CobblestoneGray.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Pro_MaxDef_ColonialSlate.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Pro_MaxDef_Driftwood.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Pro_MaxDef_GeorgetownGray.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Pro_MaxDef_HeatherBlend.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Pro_MaxDef_MoireBlack.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Pro_MaxDef_MojaveTan.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Pro_MaxDef_Pewter.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Pro_MaxDef_PewterWood.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Pro_MaxDef_PrairieWood.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Pro_MaxDef_ResawnShake.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Pro_MaxDef_Shenandoah.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Pro_MaxDef_SilverBirch.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Pro_MaxDef_SunriseCedar.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Pro_MaxDef_WeatheredWood.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Pro_Solaris_BurntSienna.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Pro_Solaris_MaxDef_BurntSienna.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Pro_Solaris_MaxDef_GeorgetownGray.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Pro_Solaris_MaxDef_HeatherBlend.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Pro_Solaris_MaxDef_MoireBlack.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Pro_Solaris_MaxDef_ResawnShake.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Pro_Solaris_MaxDef_WeatheredWood.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Pro_Solaris_SilverBirch.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Solaris_AgedCedar.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Solaris_Birch.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Solaris_BurntSienna.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Solaris_CrystalGray.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Solaris_GeorgetownGray.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Solaris_Graphite.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Solaris_HeatherBlend.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Solaris_MistWhite.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Solaris_MoireBlack.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Solaris_MojaveTan.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Solaris_ResawnShake.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Solaris_SilverBirch.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Solaris_WeatheredWood.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_TL_BlackWalnut.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_TL_CountryGray.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_TL_MoireBlack.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_TL_Platinum.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_TL_Shenandoah.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_TL_Solaris_CountryGray.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_TL_Solaris_MoireBlack.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_TL_Solaris_Platinum.layers.json",
  "/static/materials/layerconfigs/CT_Northgate_ClimateFlex_MaxDef_BurntSienna.layers.json",
  "/static/materials/layerconfigs/CT_Northgate_ClimateFlex_MaxDef_Driftwood.layers.json",
  "/static/materials/layerconfigs/CT_Northgate_ClimateFlex_MaxDef_GeorgetownGray.layers.json",
  "/static/materials/layerconfigs/CT_Northgate_ClimateFlex_MaxDef_GraniteGray.layers.json",
  "/static/materials/layerconfigs/CT_Northgate_ClimateFlex_MaxDef_HeatherBlend.layers.json",
  "/static/materials/layerconfigs/CT_Northgate_ClimateFlex_MaxDef_HunterGreen.layers.json",
  "/static/materials/layerconfigs/CT_Northgate_ClimateFlex_MaxDef_MoireBlack.layers.json",
  "/static/materials/layerconfigs/CT_Northgate_ClimateFlex_MaxDef_Pewter.layers.json",
  "/static/materials/layerconfigs/CT_Northgate_ClimateFlex_MaxDef_ResawnShake.layers.json",
  "/static/materials/layerconfigs/CT_Northgate_ClimateFlex_MaxDef_SilverBirch.layers.json",
  "/static/materials/layerconfigs/CT_Northgate_ClimateFlex_MaxDef_WeatheredWood.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_BlackWalnut.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_BurntSienna.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_CinderBlack.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_CobblestoneGray.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_ColonialSlate.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_HunterGreen.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_MoireBlack_MaxDef.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_MojaveTan.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_PaintedDesert.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Pewter.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_Pewterwood.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_ResawnShake.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_SilverBirch.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_SunriseCedar.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_ThunderstormGray.layers.json",
  "/static/materials/layerconfigs/HorizontalPlank_Cedar.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_AdobeWells.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_Frostwood.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_ParkShadows.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_Silverthorn.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_StoneBay.layers.json",
  "/static/materials/layerconfigs/Brick_GlenGery_AntiqueWhite.layers.json",
  "/static/materials/layerconfigs/Brick_GlenGery_AztecWhite.layers.json",
  "/static/materials/layerconfigs/Brick_GlenGery_Birch.layers.json",
  "/static/materials/layerconfigs/Brick_GlenGery_Casablanca.layers.json",
  "/static/materials/layerconfigs/Brick_GlenGery_WilliamsburgBradford.layers.json",
  "/static/materials/layerconfigs/Brick_GlenGery_WilliamsburgCherryCreek.layers.json",
  "/static/materials/layerconfigs/Brick_GlenGery_WilliamsburgHampton.layers.json",
  "/static/materials/layerconfigs/Brick_RedRiver_AlpineFog.layers.json",
  "/static/materials/layerconfigs/Brick_RedRiver_CrescentGrove.layers.json",
  "/static/materials/layerconfigs/Brick_RedRiver_FireOak.layers.json",
  "/static/materials/layerconfigs/Brick_RedRiver_Glenwood.layers.json",
  "/static/materials/layerconfigs/Brick_RedRiver_SaltPlains.layers.json",
  "/static/materials/layerconfigs/Brick_RedRiver_ShadowFalls.layers.json",
  "/static/materials/layerconfigs/Brick_RedRiver_ShelteredBluff.layers.json",
  "/static/materials/layerconfigs/Brick_RedRiver_Tecomate.layers.json",
  "/static/materials/layerconfigs/Wood_PlyGem_CarbonBlack.layers.json",
  "/static/materials/layerconfigs/Wood_PlyGem_DarkWalnut.layers.json",
  "/static/materials/layerconfigs/Wood_PlyGem_Espresso.layers.json",
  "/static/materials/layerconfigs/Wood_PlyGem_NaturalWalnut.layers.json",
  "/static/materials/layerconfigs/Brick_Lusco_PearlRiver.layers.json",
  "/static/materials/layerconfigs/Brick_RedRiver_WellsValley.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_BlackShadow.layers.json",
  "/static/materials/layerconfigs/Wood_Cedar_Beachwood.layers.json",
  "/static/materials/layerconfigs/Wood_Cedar_BlackOak.layers.json",
  "/static/materials/layerconfigs/Wood_Cedar_DriftwoodGray.layers.json",
  "/static/materials/layerconfigs/Wood_Cedar_Ebony.layers.json",
  "/static/materials/layerconfigs/Wood_Cedar_Mink.layers.json",
  "/static/materials/layerconfigs/Wood_Cedar_Natural.layers.json",
  "/static/materials/layerconfigs/Wood_Cedar_Sandstone.layers.json",
  "/static/materials/layerconfigs/Stone_CS_CL_BlackRundle_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Cultured_CL_BlackRundle.layers.json",
  "/static/materials/layerconfigs/Stone_CS_CL_GrandMesa_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Cultured_CL_GrandMesa.layers.json",
  "/static/materials/layerconfigs/Stone_ES_ML_MesaVerde_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_ML_MesaVerde.layers.json",
  "/static/materials/layerconfigs/Wood_NaturalCherry_Alamo.layers.json",
  "/static/materials/layerconfigs/Brick_Mer_ChimneyMountain.layers.json",
  "/static/materials/layerconfigs/Brick_Mer_PortHuron.layers.json",
  "/static/materials/layerconfigs/Tamko_RusticBlack.layers.json",
  "/static/materials/layerconfigs/Tamko_VirginiaSlate.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_Augusta.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_HamptonMill.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_OysterBay.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_PineRidge.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_RapidFalls.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_Scottsdale.layers.json",
  "/static/materials/layerconfigs/OC_Supreme_WeatheredWood.layers.json",
  "/static/materials/layerconfigs/Wood_RS_Stain_NaturalCedar.layers.json",
  "/static/materials/layerconfigs/Brick_RedRiver_BurlingtonAntique.layers.json",
  "/static/materials/layerconfigs/Brick_RedRiver_Caprock.layers.json",
  "/static/materials/layerconfigs/Brick_RedRiver_CypressSprings.layers.json",
  "/static/materials/layerconfigs/Brick_RedRiver_Mayfield.layers.json",
  "/static/materials/layerconfigs/Brick_RedRiver_Ridgemont.layers.json",
  "/static/materials/layerconfigs/Brick_RedRiver_Silverado.layers.json",
  "/static/materials/layerconfigs/Tamko_OxfordGrey.layers.json",
  "/static/materials/layerconfigs/Tamko_WeatheredWood.layers.json",
  "/static/materials/layerconfigs/Stone_RM_RC_SilvermistChopped.layers.json",
  "/static/materials/layerconfigs/Stone_RM_Sawn_BlancoChopped.layers.json",
  "/static/materials/layerconfigs/Stone_RM_Sawn_LuedersChopped.layers.json",
  "/static/materials/layerconfigs/Stone_RM_SB_LuedersOnyxChopped.layers.json",
  "/static/materials/layerconfigs/Stone_RM_SB_OpalChopped.layers.json",
  "/static/materials/layerconfigs/Stone_RM_Sawn_TexasMixChopped.layers.json",
  "/static/materials/layerconfigs/Stone_RM_WS_WaterfordLimestone.layers.json",
  "/static/materials/layerconfigs/Stone_RM_RoughChopped_SilvermistChopped_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_RM_Sawn_BlancoChopped_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_RM_Sawn_LuedersChopped_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_RM_Sawn_LuedersOnyxChopped_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_RM_Sawn_OpalChopped_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_RM_Sawn_TexasMixChopped_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_RM_Sawn_WaterfordLimestone_Trim.layers.json",
  "/static/materials/layerconfigs/Brick_SW_7004_Snowbound.layers.json",
  "/static/materials/layerconfigs/Wood_GS_Stain_Black1173.layers.json",
  "/static/materials/layerconfigs/Wood_GS_Stain_Chestnut1176.layers.json",
  "/static/materials/layerconfigs/Wood_GS_Stain_Coffee1177.layers.json",
  "/static/materials/layerconfigs/Wood_GS_Stain_Hickory1178.layers.json",
  "/static/materials/layerconfigs/Wood_GS_Stain_HoneyMaple1179.layers.json",
  "/static/materials/layerconfigs/Wood_GS_Stain_Mahogany1180.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3507_Riverwood.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3524_Chestnut.layers.json",
  "/static/materials/layerconfigs/CHI_Wood_AccentsCedar.layers.json",
  "/static/materials/layerconfigs/CHI_Wood_AccentsDarkOak.layers.json",
  "/static/materials/layerconfigs/CHI_Wood_AccentsDriftwood.layers.json",
  "/static/materials/layerconfigs/CHI_Wood_AccentsMahogany.layers.json",
  "/static/materials/layerconfigs/CHI_Wood_AccentsWalnut.layers.json",
  "/static/materials/layerconfigs/CHI_Wood_CarbonOak.layers.json",
  "/static/materials/layerconfigs/CHI_Wood_ClassicWoodgrain.layers.json",
  "/static/materials/layerconfigs/CHI_Wood_ModernWoodgrain.layers.json",
  "/static/materials/layerconfigs/CHI_Wood_NaturalOak.layers.json",
  "/static/materials/layerconfigs/OC_Oakridge_Brownwood.layers.json",
  "/static/materials/layerconfigs/OC_Oakridge_DesertTan.layers.json",
  "/static/materials/layerconfigs/OC_Oakridge_Driftwood.layers.json",
  "/static/materials/layerconfigs/OC_Oakridge_EstateGray.layers.json",
  "/static/materials/layerconfigs/OC_Oakridge_OnyxBlack.layers.json",
  "/static/materials/layerconfigs/OC_Oakridge_Teak.layers.json",
  "/static/materials/layerconfigs/OC_Oakridge_WilliamsburgGray.layers.json",
  "/static/materials/layerconfigs/Stone_CDS_BiancoBlend_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_CDS_Blend_Bianco.layers.json",
  "/static/materials/layerconfigs/Stone_CDS_NiveoVolterra_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_CDS_Volterra_Niveo.layers.json",
  "/static/materials/layerconfigs/Stone_CDS_TurinVolterra_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_CDS_Volterra_Turin.layers.json",
  "/static/materials/layerconfigs/Stone_HS_BasswoodGrey_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Halquist_Ledge_BasswoodGrey.layers.json",
  "/static/materials/layerconfigs/Stone_PS_Bluegrass_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_PS_Bluegrass.layers.json",
  "/static/materials/layerconfigs/Stone_PS_PortlandMist_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_PS_PortlandMist.layers.json",
  "/static/materials/layerconfigs/Stone_PS_PortlandSmokeFlatsCarton_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_PS_PortlandSmokeFlatsCarton.layers.json",
  "/static/materials/layerconfigs/CHI_Wood_AccentsCedar_V.layers.json",
  "/static/materials/layerconfigs/CHI_Wood_AccentsDarkOak_V.layers.json",
  "/static/materials/layerconfigs/CHI_Wood_AccentsDriftwood_V.layers.json",
  "/static/materials/layerconfigs/CHI_Wood_AccentsMahogany_V.layers.json",
  "/static/materials/layerconfigs/CHI_Wood_AccentsWalnut_V.layers.json",
  "/static/materials/layerconfigs/CHI_Wood_CarbonOak_V.layers.json",
  "/static/materials/layerconfigs/CHI_Wood_ClassicWoodgrain_V.layers.json",
  "/static/materials/layerconfigs/CHI_Wood_ModernWoodgrain_V.layers.json",
  "/static/materials/layerconfigs/CHI_Wood_NaturalOak_V.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3125_RanchOak.layers.json",
  "/static/materials/layerconfigs/Stone_EV_ChiltonMCV_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_EV_ChiltonMCV.layers.json",
  "/static/materials/layerconfigs/Stone_EV_EdenMCV_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_EV_EdenMCV.layers.json",
  "/static/materials/layerconfigs/Stone_EV_OakfieldMCV_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_EV_OakfieldMCV.layers.json",
  "/static/materials/layerconfigs/Stone_EV_Windsor_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_EV_Windsor.layers.json",
  "/static/materials/layerconfigs/Stone_FDL_GraphiteManor_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_FDL_GraphiteManor.layers.json",
  "/static/materials/layerconfigs/Stone_FDL_FondDuLacCountry_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_FDL_FondDuLacCountry.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3125_RanchOak_V.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3507_Riverwood_V.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3524_Chestnut_V.layers.json",
  "/static/materials/layerconfigs/Atlas_BlackShadow.layers.json",
  "/static/materials/layerconfigs/Brick_RedRiver_Amarylis.layers.json",
  "/static/materials/layerconfigs/Brick_GS_Domino.layers.json",
  "/static/materials/layerconfigs/Brick_GS_BourbonTrail.layers.json",
  "/static/materials/layerconfigs/Brick_GS_CavalryGray.layers.json",
  "/static/materials/layerconfigs/Brick_GS_NolinRiver.layers.json",
  "/static/materials/layerconfigs/Brick_GS_SwanCreek.layers.json",
  "/static/materials/layerconfigs/Brick_HB_CypressPoint.layers.json",
  "/static/materials/layerconfigs/Wood_GS_Stain_AgedOak1024.layers.json",
  "/static/materials/layerconfigs/Stone_MG_AustinWhite_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_MGBS_AustinWhite.layers.json",
  "/static/materials/layerconfigs/Stone_MG_Charcoal_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_MGBS_Charcoal.layers.json",
  "/static/materials/layerconfigs/Stone_MG_PepperedWhite_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_MGBS_PepperedWhite.layers.json",
  "/static/materials/layerconfigs/Stone_MG_Walnut_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_MGBS_Walnut.layers.json",
  "/static/materials/layerconfigs/Brick_Claymex_LeMont.layers.json",
  "/static/materials/layerconfigs/Brick_Claymex_Oxford.layers.json",
  "/static/materials/layerconfigs/Brick_Tri_JeffersonPark.layers.json",
  "/static/materials/layerconfigs/Brick_Tri_SeelyTown.layers.json",
  "/static/materials/layerconfigs/IKO_CharcoalGrey.layers.json",
  "/static/materials/layerconfigs/IKO_Driftwood.layers.json",
  "/static/materials/layerconfigs/IKO_DualBlack.layers.json",
  "/static/materials/layerconfigs/IKO_DualBrown.layers.json",
  "/static/materials/layerconfigs/IKO_DualGrey.layers.json",
  "/static/materials/layerconfigs/IKO_EarthtoneCedar.layers.json",
  "/static/materials/layerconfigs/IKO_HarvardSlate.layers.json",
  "/static/materials/layerconfigs/IKO_Weatherwood.layers.json",
  "/static/materials/layerconfigs/ER3723_AdobeBlend.layers.json",
  "/static/materials/layerconfigs/Stone_StoneWorks_AppalacianCutStonePA_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_SW_CS_AppalachianPA.layers.json",
  "/static/materials/layerconfigs/Brick_Tri_DoverWhite.layers.json",
  "/static/materials/layerconfigs/Stone_DutchQuality_Elkwood_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_DutchQuality_Elkwood.layers.json",
  "/static/materials/layerconfigs/Stone_DutchQuality_Pennsylvania_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_Pennsylvania.layers.json",
  "/static/materials/layerconfigs/Stone_CH_AutumnBreeze_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_CH_AutumnBreeze.layers.json",
  "/static/materials/layerconfigs/Stone_CH_GlacialBluff_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_CH_GlacialBluff.layers.json",
  "/static/materials/layerconfigs/Stone_CH_OldCastle_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_CH_OldCastle.layers.json",
  "/static/materials/layerconfigs/Brick_GS_Ashview.layers.json",
  "/static/materials/layerconfigs/Brick_GS_Winstar.layers.json",
  "/static/materials/layerconfigs/DiamondPetra_Tontitown_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_DP_Tontitown.layers.json",
  "/static/materials/layerconfigs/Stone_DutchQuality_Columbus_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_Columbus.layers.json",
  "/static/materials/layerconfigs/Stone_Env_KentuckyCutstone_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Env_CS_Kentucky.layers.json",
  "/static/materials/layerconfigs/Stone_Env_TexasCutstone_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Env_CS_Texas.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_Brookstone.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_MountainBrook.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_Rockwell.layers.json",
  "/static/materials/layerconfigs/Stone_Horizon_Cumberland_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Horizon_Cumberland.layers.json",
  "/static/materials/layerconfigs/Stone_Horizon_Hermitage_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Horizon_Hermitage.layers.json",
  "/static/materials/layerconfigs/Stone_Horizon_MossyCreek_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Horizon_MossyCreek.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3542_Charwood_V.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3542_Charwood.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_GlacierBay.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_Highstone.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_WhiteRiverRock.layers.json",
  "/static/materials/layerconfigs/Brick_Bilco_Stardust.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3501_Redwood.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3502_MissionWall.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3503_WhiteBirch.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3504_Woodridge.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3505_YankeeBarn.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3508_CoveredBridge.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3509_BajaBeige.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3511_CedarBark.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3512_CiderMill.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3513_SpiceChest.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3518_Hawthorne.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3520_Ficus.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3521_Crossroads.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3522_BanyanBrown.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3530_MossOlive.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3531_BlueShadow.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3532_HillCountry.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3533_Leeward.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3535_Foliage.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3540_MountainAsh.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3541_HarborMist.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3501_Redwood_V.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3502_MissionWall_V.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3503_WhiteBirch_V.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3504_Woodridge_V.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3505_YankeeBarn_V.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3508_CoveredBridge_V.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3509_BajaBeige_V.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3511_CedarBark_V.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3512_CiderMill_V.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3513_SpiceChest_V.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3518_Hawthorne_V.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3520_Ficus_V.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3521_Crossroads_V.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3522_BanyanBrown_V.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3530_MossOlive_V.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3531_BlueShadow_V.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3532_HillCountry_V.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3533_Leeward_V.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3535_Foliage_V.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3540_MountainAsh_V.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3541_HarborMist_V.layers.json",
  "/static/materials/layerconfigs/Stone_Cultured_Buckeye.layers.json",
  "/static/materials/layerconfigs/Stone_Cultured_SL_Aspen.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_CS_WhiteBark.layers.json",
  "/static/materials/layerconfigs/Stone_Cultured_SL_EchoRidge.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_RC_AutumnLeaf.layers.json",
  "/static/materials/layerconfigs/Stone_Cultured_AL_UmberCreek.layers.json",
  "/static/materials/layerconfigs/Stone_Cultured_CL_Ashfall.layers.json",
  "/static/materials/layerconfigs/Stone_Cultured_CL_WolfCreek.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_ML_Sierra.layers.json",
  "/static/materials/layerconfigs/Stone_Cultured_DSL_Rubicon.layers.json",
  "/static/materials/layerconfigs/Stone_Cultured_SL_Gray.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_EL_IronMill.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_RL_Clearwater.layers.json",
  "/static/materials/layerconfigs/Stone_CS_AlpineLedgestone_UmberCreek_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_CS_Buckeye_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_CS_CL_Ashfall_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_CS_CL_WolfCreek_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_CS_DrystackLedgestone_Rubicon_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_CS_SouthernLedgestone_Aspen_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_CS_SouthernLedgestone_EchoRidge_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_CS_SouthernLedgestone_Gray_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_ES_Cliffstone_WhiteBark_Trim_OLD.layers.json",
  "/static/materials/layerconfigs/Stone_ES_EuropeanLedge_IronMill_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_ES_ML_Sierra_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_ES_Roughcut_AutumnLeaf_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_ES_RusticLedge_Clearwater_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_DutchQuality_Ashen_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_DutchQuality_Ashen.layers.json",
  "/static/materials/layerconfigs/Stone_DutchQuality_QuailGrey_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_DutchQuality_QuailGrey.layers.json",
  "/static/materials/layerconfigs/Stone_DutchQuality_WinterPoint_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_DutchQuality_WinterPoint.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_ForestHills.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_SanJose.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_Seabrook.layers.json",
  "/static/materials/layerconfigs/Stone_Horizon_CanyonRidge_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Horizon_CanyonRidge.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_EdgeCut_Tundra_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_EC_Tundra.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_RidgeCut_Silverton_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_RC_Silverton.layers.json",
  "/static/materials/layerconfigs/Wood_Stain_Alluvium417.layers.json",
  "/static/materials/layerconfigs/Wood_Stain_Carbon409.layers.json",
  "/static/materials/layerconfigs/Wood_Stain_Greenwood413.layers.json",
  "/static/materials/layerconfigs/Wood_Stain_Oakwood435.layers.json",
  "/static/materials/layerconfigs/Wood_Stain_Smokewood407.layers.json",
  "/static/materials/layerconfigs/Wood_Stain_ToastedBarrell405.layers.json",
  "/static/materials/layerconfigs/Stone_Horizon_HarborBluff_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Horizon_HarborBluff.layers.json",
  "/static/materials/layerconfigs/Wood_GS_Stain_AgedOak1024_V.layers.json",
  "/static/materials/layerconfigs/Wood_GS_Stain_Black1173_V.layers.json",
  "/static/materials/layerconfigs/Wood_GS_Stain_Chestnut1176_V.layers.json",
  "/static/materials/layerconfigs/Wood_GS_Stain_Coffee1177_V.layers.json",
  "/static/materials/layerconfigs/Wood_GS_Stain_Hickory1178_V.layers.json",
  "/static/materials/layerconfigs/Wood_GS_Stain_HoneyMaple1179_V.layers.json",
  "/static/materials/layerconfigs/Wood_GS_Stain_Mahogany1180_V.layers.json",
  "/static/materials/layerconfigs/Wood_RS_Stain_NaturalCedar_V.layers.json",
  "/static/materials/layerconfigs/Wood_Stain_Alluvium417_V.layers.json",
  "/static/materials/layerconfigs/Wood_Stain_Carbon409_V.layers.json",
  "/static/materials/layerconfigs/Wood_Stain_Greenwood413_V.layers.json",
  "/static/materials/layerconfigs/Wood_Stain_Oakwood435_V.layers.json",
  "/static/materials/layerconfigs/Wood_Stain_Smokewood407_V.layers.json",
  "/static/materials/layerconfigs/Wood_Stain_ToastedBarrell405_V.layers.json",
  "/static/materials/layerconfigs/Paver_Belgard_Napoli.layers.json",
  "/static/materials/layerconfigs/OC_Oakridge_Peppercorn.layers.json",
  "/static/materials/layerconfigs/Brick_GS_BarnsleyTudor.layers.json",
  "/static/materials/layerconfigs/Brick_GS_KeenelandElite.layers.json",
  "/static/materials/layerconfigs/Brick_GS_ShadowGrey.layers.json",
  "/static/materials/layerconfigs/Brick_US_Blackberry.layers.json",
  "/static/materials/layerconfigs/Brick_GS_ManorHouseTudor.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_FrenchChateaux.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_MochaBrownAntique.layers.json",
  "/static/materials/layerconfigs/Brick_Binsa_AmericanAntique.layers.json",
  "/static/materials/layerconfigs/Brick_Binsa_HillStone.layers.json",
  "/static/materials/layerconfigs/Brick_RedRiver_GlisteningSprings.layers.json",
  "/static/materials/layerconfigs/Brick_Tri_Porter.layers.json",
  "/static/materials/layerconfigs/Stone_Cobra_FallBlend.layers.json",
  "/static/materials/layerconfigs/Stone_Cobra_TexasMix.layers.json",
  "/static/materials/layerconfigs/Stone_Cobra_White.layers.json",
  "/static/materials/layerconfigs/Stone_Cobra_FallBlend_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Cobra_TexasMix_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Cobra_White_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_Ledgestone_Osage_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_Ledge_Osage.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_Limestone_Amherst_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_Lime_Amherst.layers.json",
  "/static/materials/layerconfigs/Brick_GS_AlpineSelect.layers.json",
  "/static/materials/layerconfigs/Brick_GS_VintagePort.layers.json",
  "/static/materials/layerconfigs/Brick_GS_Wynnewood.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_Ledgestone_Rushmore_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_Ledge_Rushmore.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_Ledgestone_Saginaw_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_Ledge_Saginaw.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_Limestone_Allegheny_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_Lime_Allegheny.layers.json",
  "/static/materials/layerconfigs/Brick_GS_NewcastleGray.layers.json",
  "/static/materials/layerconfigs/Brick_GS_OldEdisto.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3561_Cedar_V.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3561_Cedar.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_CasaBlanca.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_Silvercreek.layers.json",
  "/static/materials/layerconfigs/Brick_Bilco_Everest.layers.json",
  "/static/materials/layerconfigs/Brick_Bilco_GrayMist.layers.json",
  "/static/materials/layerconfigs/Brick_Bilco_Scottsdale.layers.json",
  "/static/materials/layerconfigs/Brick_RedRiver_FoggyMorning.layers.json",
  "/static/materials/layerconfigs/Brick_RedRiver_SnowMist.layers.json",
  "/static/materials/layerconfigs/Brick_RedRiver_WhiteRiverRock.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3025_Caribou_V.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3025_Caribou.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_Callisburg.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_CameronHills.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_DentonAntique.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_OldFrancisco.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_Winterstone.layers.json",
  "/static/materials/layerconfigs/Pella_Wood_Black_V.layers.json",
  "/static/materials/layerconfigs/Pella_Wood_Black.layers.json",
  "/static/materials/layerconfigs/Pella_Wood_Charcoal_V.layers.json",
  "/static/materials/layerconfigs/Pella_Wood_Charcoal.layers.json",
  "/static/materials/layerconfigs/Pella_Wood_DarkMahogany_V.layers.json",
  "/static/materials/layerconfigs/Pella_Wood_DarkMahogany.layers.json",
  "/static/materials/layerconfigs/Pella_Wood_EarlyAmerican_V.layers.json",
  "/static/materials/layerconfigs/Pella_Wood_EarlyAmerican.layers.json",
  "/static/materials/layerconfigs/Pella_Wood_Espresso_V.layers.json",
  "/static/materials/layerconfigs/Pella_Wood_Espresso.layers.json",
  "/static/materials/layerconfigs/Pella_Wood_GoldenOak_V.layers.json",
  "/static/materials/layerconfigs/Pella_Wood_GoldenOak.layers.json",
  "/static/materials/layerconfigs/Pella_Wood_Natural_V.layers.json",
  "/static/materials/layerconfigs/Pella_Wood_Natural.layers.json",
  "/static/materials/layerconfigs/Pella_Wood_Provincial_V.layers.json",
  "/static/materials/layerconfigs/Pella_Wood_Provincial.layers.json",
  "/static/materials/layerconfigs/Pella_Wood_RedMahogany_V.layers.json",
  "/static/materials/layerconfigs/Pella_Wood_RedMahogany.layers.json",
  "/static/materials/layerconfigs/Brick_GS_SpanishMoss.layers.json",
  "/static/materials/layerconfigs/Brick_Tri_FortMill.layers.json",
  "/static/materials/layerconfigs/Brick_Tri_LibbyMill.layers.json",
  "/static/materials/layerconfigs/Brick_GS_CapersIsland.layers.json",
  "/static/materials/layerconfigs/Brick_GS_StoneMountain.layers.json",
  "/static/materials/layerconfigs/Brick_GS_HeritageTrail.layers.json",
  "/static/materials/layerconfigs/Stone_Cultured_CL_EchoRidge.layers.json",
  "/static/materials/layerconfigs/Stone_Cultured_CL_Gunnison.layers.json",
  "/static/materials/layerconfigs/Stone_Cultured_CL_Wheaton.layers.json",
  "/static/materials/layerconfigs/Stone_RA_DQ_WinterPoint.layers.json",
  "/static/materials/layerconfigs/Stone_CS_CL_EchoRidge_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_CS_CL_Gunnison_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_CS_CL_Wheaton_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_RA_DQ_WinterPoint_Trim.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_SlateGray.layers.json",
  "/static/materials/layerconfigs/Stone_ROCKCWPLT_ChoppedWhite.layers.json",
  "/static/materials/layerconfigs/Stone_ROCKCWPLT_ChoppedWhite_Trim.layers.json",
  "/static/materials/layerconfigs/Brick_Claymex_Alpine.layers.json",
  "/static/materials/layerconfigs/Brick_Claymex_Brownfield.layers.json",
  "/static/materials/layerconfigs/Brick_Claymex_Cobblestone.layers.json",
  "/static/materials/layerconfigs/Brick_Claymex_Keystone.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3027_Driftwood_V.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3027_Driftwood.layers.json",
  "/static/materials/layerconfigs/Brick_Claymex_Onyx.layers.json",
  "/static/materials/layerconfigs/Brick_Claymex_Pewter.layers.json",
  "/static/materials/layerconfigs/Brick_Claymex_Woodcreek.layers.json",
  "/static/materials/layerconfigs/Brick_Claymex_York.layers.json",
  "/static/materials/layerconfigs/Stone_ROCKBLUE_ChoppedBlueLueders_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_ROCKBLUE_ChoppedBlueLueders.layers.json",
  "/static/materials/layerconfigs/Stone_ROCKCCAVE_ChoppedCaveRegular_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_ROCKCCAVE_ChoppedCaveRegular.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_DB2317_Fig_V.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_DB2317_Fig.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3566_DouglasFir_V.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3566_DouglasFir.layers.json",
  "/static/materials/layerconfigs/Brick_PGH_Bark.layers.json",
  "/static/materials/layerconfigs/Brick_PGH_CharacterPutty.layers.json",
  "/static/materials/layerconfigs/Brick_PGH_CharacterRedRock.layers.json",
  "/static/materials/layerconfigs/Brick_Harristone_Charleston.layers.json",
  "/static/materials/layerconfigs/Brick_Harristone_DoveGrey.layers.json",
  "/static/materials/layerconfigs/Brick_Harristone_WhiteSand.layers.json",
  "/static/materials/layerconfigs/Stone_Harristone_Chocolate_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Harristone_Cream_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Harristone_Grey_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Harristone_Tan_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Harristone_Taupe_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Harristone_Div_Huntington.layers.json",
  "/static/materials/layerconfigs/Stone_Harristone_Div_SilverStrand.layers.json",
  "/static/materials/layerconfigs/Stone_Harristone_Div_WhiteSand.layers.json",
  "/static/materials/layerconfigs/Stone_Harristone_DS_Highland.layers.json",
  "/static/materials/layerconfigs/Stone_Harristone_DS_Kingstown.layers.json",
  "/static/materials/layerconfigs/Stone_Harristone_DS_Slate.layers.json",
  "/static/materials/layerconfigs/Stone_Harristone_DS_Stirling.layers.json",
  "/static/materials/layerconfigs/Stone_Harristone_Lueders_FlintHills.layers.json",
  "/static/materials/layerconfigs/Stone_Harristone_LS_FlintHills.layers.json",
  "/static/materials/layerconfigs/Stone_Harristone_Tumbled_AustinWhite.layers.json",
  "/static/materials/layerconfigs/Stone_Harristone_Tumbled_Sunlit.layers.json",
  "/static/materials/layerconfigs/Stone_HarristoneUintah_Midnight.layers.json",
  "/static/materials/layerconfigs/Stone_HarristoneUintah_RockyCliff.layers.json",
  "/static/materials/layerconfigs/Stone_Harristone_Uintah_Slate.layers.json",
  "/static/materials/layerconfigs/Stone_Harristone_WhiteSand_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Harristone_Charcoal_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Pioneer_Belgrade.layers.json",
  "/static/materials/layerconfigs/Stone_Pioneer_Sedona.layers.json",
  "/static/materials/layerconfigs/Masonry_Stone_Bello_Cobblestone_NewEngland_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Bello_Cob_NewEngland.layers.json",
  "/static/materials/layerconfigs/Masonry_Stone_Bello_Cobblestone_Pequea_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Bello_Cob_Pequea.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Old_NorrisGray_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Old_NorrisGray.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_ChiselCut_Brindle_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_CC_Brindle.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_ChiselCut_Silverlake_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_CC_Silverlake.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_DryStack_Pearl_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_DS_Pearl.layers.json",
  "/static/materials/layerconfigs/Stone_RM_Sawn_CafeBlend_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_RM_Sawn_CafeBlend.layers.json",
  "/static/materials/layerconfigs/Stone_RM_Sawn_GraphiteFawnBlend_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_RM_SB_GraphiteFawnBlend.layers.json",
  "/static/materials/layerconfigs/Brick_Bilco_Camel.layers.json",
  "/static/materials/layerconfigs/Brick_Bilco_Graystone.layers.json",
  "/static/materials/layerconfigs/Brick_Bilco_Onyx.layers.json",
  "/static/materials/layerconfigs/Brick_Bilco_Phoenix.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_NaturalCut_Ashworth_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_NC_Ashworth.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_PrecisionFit_AdobeSands_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_PF_AdobeSands.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_PrecisionFit_Driftwood_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_PF_Driftwood.layers.json",
  "/static/materials/layerconfigs/Brick_ProVia_Boston.layers.json",
  "/static/materials/layerconfigs/Brick_ProVia_Cobblestone.layers.json",
  "/static/materials/layerconfigs/Brick_ProVia_Delaware.layers.json",
  "/static/materials/layerconfigs/Brick_ProVia_Midnight.layers.json",
  "/static/materials/layerconfigs/Brick_Heritage_Ashwood.layers.json",
  "/static/materials/layerconfigs/Stone_Bello_Brecknock_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Bello_Brecknock_OLD.layers.json",
  "/static/materials/layerconfigs/Brick_GS_Cortez.layers.json",
  "/static/materials/layerconfigs/Brick_US_Monaco.layers.json",
  "/static/materials/layerconfigs/Brick_GS_BradfordHall.layers.json",
  "/static/materials/layerconfigs/Stone_QS_DS_Susquehanna.layers.json",
  "/static/materials/layerconfigs/Stone_QS_Cob_PALime.layers.json",
  "/static/materials/layerconfigs/Stone_QS_FS_LebanonLime.layers.json",
  "/static/materials/layerconfigs/Stone_QS_Cob_Conestoga.layers.json",
  "/static/materials/layerconfigs/Stone_QS_Cob_Eggshell.layers.json",
  "/static/materials/layerconfigs/Stone_QS_Cob_Rockvale.layers.json",
  "/static/materials/layerconfigs/Stone_QS_DS_Pumice.layers.json",
  "/static/materials/layerconfigs/Stone_QS_FS_NewEngland.layers.json",
  "/static/materials/layerconfigs/Stone_QS_Cobblestone_Conestoga_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_QS_Cobblestone_Eggshell_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_QS_Cobblestone_PALime_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_QS_Cobblestone_Rockvale_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_QS_Drystack_Pumice_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_QS_Drystack_Susquehanna_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_QS_Fieldstone_LebanonLime_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_QS_Fieldstone_NewEngland_Trim.layers.json",
  "/static/materials/layerconfigs/Brick_GS_Graymoor.layers.json",
  "/static/materials/layerconfigs/Brick_Tri_CapeFear.layers.json",
  "/static/materials/layerconfigs/Brick_GS_ClaytonFalls.layers.json",
  "/static/materials/layerconfigs/GAF_PewterGray.layers.json",
  "/static/materials/layerconfigs/Brick_GS_RedColonial.layers.json",
  "/static/materials/layerconfigs/Brick_Tri_Nantucket.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_StackLedge_Fallbrook_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_SL_Fallbrook.layers.json",
  "/static/materials/layerconfigs/Brick_US_OldJackson.layers.json",
  "/static/materials/layerconfigs/Brick_GS_Valor.layers.json",
  "/static/materials/layerconfigs/Patio_Irwin_PennsylvaniaFullColor.layers.json",
  "/static/materials/layerconfigs/Stone_Irwin_FS_Andover.layers.json",
  "/static/materials/layerconfigs/Stone_Irwin_FS_ChocolateGray.layers.json",
  "/static/materials/layerconfigs/Stone_Irwin_FS_DoveGray.layers.json",
  "/static/materials/layerconfigs/Stone_Irwin_FS_WesternMaryland.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_AnsleyPark.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_Menawa.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_MushroomBrown.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_Texas.layers.json",
  "/static/materials/layerconfigs/OC_Oakridge_SierraGray.layers.json",
  "/static/materials/layerconfigs/Stone_MV_Adaline_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_MV_Adaline.layers.json",
  "/static/materials/layerconfigs/Stone_MV_Appalachian_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_MV_Appalachian.layers.json",
  "/static/materials/layerconfigs/Stone_MV_BlackForest_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_MV_BlackForest.layers.json",
  "/static/materials/layerconfigs/Stone_MV_Tuscany_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_MV_Tuscany.layers.json",
  "/static/materials/layerconfigs/LS_JH_ArcticWhite_Cobblestone.layers.json",
  "/static/materials/layerconfigs/LS_JH_TimberBark_ArcticWhite.layers.json",
  "/static/materials/layerconfigs/LS_JH_TimberBark_RichEspresso.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_SS_Nantucket.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_SS_ChapelHill.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Stack_Coastal.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_GrayStainless.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_NorrisGray.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Texas.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Rubble_Tulsa.layers.json",
  "/static/materials/layerconfigs/Brick_Tri_FederalHill.layers.json",
  "/static/materials/layerconfigs/Brick_Tri_Portsmouth.layers.json",
  "/static/materials/layerconfigs/Brick_Tri_RiverStreet.layers.json",
  "/static/materials/layerconfigs/Brick_Tri_Wilmington.layers.json",
  "/static/materials/layerconfigs/Stone_CDS_Bella.layers.json",
  "/static/materials/layerconfigs/Stone_CDS_Carbone.layers.json",
  "/static/materials/layerconfigs/Stone_CDS_Gola.layers.json",
  "/static/materials/layerconfigs/Stone_CDS_Matera.layers.json",
  "/static/materials/layerconfigs/Stone_CDS_Niveo.layers.json",
  "/static/materials/layerconfigs/Stone_CDS_Turin.layers.json",
  "/static/materials/layerconfigs/Stone_CDS_Terracina.layers.json",
  "/static/materials/layerconfigs/Stone_CDS_Trim_Cream.layers.json",
  "/static/materials/layerconfigs/Stone_CDS_Trim_Fumo.layers.json",
  "/static/materials/layerconfigs/Stone_CDS_Trim_Mezzo.layers.json",
  "/static/materials/layerconfigs/Stone_CDS_Trim_Sage.layers.json",
  "/static/materials/layerconfigs/Stone_CDS_Trim_Terra.layers.json",
  "/static/materials/layerconfigs/LS_JH_AgedPewter_ArcticWhite.layers.json",
  "/static/materials/layerconfigs/LS_JH_MontereyTaupe_ArcticWhite.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_SL_Torino.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_StackLedge_Torino_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_DutchQuality_Sagewood_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_Sagewood.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_StackLedge_Steinhaus_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_SL_Steinhaus.layers.json",
  "/static/materials/layerconfigs/Brick_Tri_ChesapeakeGrey.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_OldTavern.layers.json",
  "/static/materials/layerconfigs/Brick_PVStone_Colonial.layers.json",
  "/static/materials/layerconfigs/Brick_PVStone_Neptune.layers.json",
  "/static/materials/layerconfigs/Stone_PVStone_Dune.layers.json",
  "/static/materials/layerconfigs/Stone_PVStone_Havana.layers.json",
  "/static/materials/layerconfigs/Stone_PVStone_Havasupai.layers.json",
  "/static/materials/layerconfigs/Stone_PVStone_Jurasic.layers.json",
  "/static/materials/layerconfigs/Stone_PVStone_Lermara.layers.json",
  "/static/materials/layerconfigs/Stone_PVStone_Mahogany.layers.json",
  "/static/materials/layerconfigs/Brick_Binsa_EnglishDove.layers.json",
  "/static/materials/layerconfigs/Brick_Claymex_Aspen.layers.json",
  "/static/materials/layerconfigs/Stone_RM_Bluebonnet_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_RM_SB_BlancoChopped.layers.json",
  "/static/materials/layerconfigs/Stone_RM_Sawn_LuedersBuff.layers.json",
  "/static/materials/layerconfigs/Stone_RM_LuedersCharcoal.layers.json",
  "/static/materials/layerconfigs/Tamko_AntiqueSlate.layers.json",
  "/static/materials/layerconfigs/Tamko_RusticSlate.layers.json",
  "/static/materials/layerconfigs/Brick_Tri_Oakton.layers.json",
  "/static/materials/layerconfigs/Brick_US_OldWaverly.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_StackLedge_Sienna_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_SL_Sienna.layers.json",
  "/static/materials/layerconfigs/Stone_Horizon_Hickory_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Horizon_Hickory.layers.json",
  "/static/materials/layerconfigs/Stone_Horizon_SmokyMountain_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Horizon_SmokyMountain.layers.json",
  "/static/materials/layerconfigs/Stone_Lurveys_Cob_Champagne.layers.json",
  "/static/materials/layerconfigs/Stone_Versetta_Charcoal_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Versetta_GranitePeak.layers.json",
  "/static/materials/layerconfigs/Stone_Versetta_NorthernAsh.layers.json",
  "/static/materials/layerconfigs/Stone_Versetta_PlumCreek.layers.json",
  "/static/materials/layerconfigs/Stone_Versetta_Sterling.layers.json",
  "/static/materials/layerconfigs/Stone_Versetta_StoneGrey_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Versetta_Taupe_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Lurveys_Cob_GraphiteManor.layers.json",
  "/static/materials/layerconfigs/Brick_Che_Magnolia.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_AdenBlend.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_Abbeville.layers.json",
  "/static/materials/layerconfigs/Malarkey_MidnightBlack.layers.json",
  "/static/materials/layerconfigs/Malarkey_NaturalWood.layers.json",
  "/static/materials/layerconfigs/Malarkey_Silverwood.layers.json",
  "/static/materials/layerconfigs/Stone_StoneCraft_Chardonnay.layers.json",
  "/static/materials/layerconfigs/Stone_CS_CL_BucksCounty_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Cultured_CL_BucksCounty.layers.json",
  "/static/materials/layerconfigs/Stone_DutchQuality_NaturalBlend_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_DutchQuality_NaturalBlend.layers.json",
  "/static/materials/layerconfigs/Stone_DutchQuality_Sienna_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_DutchQuality_Sienna.layers.json",
  "/static/materials/layerconfigs/Stone_QS_Drystack_Arizona_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_QS_DS_Arizona.layers.json",
  "/static/materials/layerconfigs/Stone_RA_DQ_Greystone_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_RA_DQ_Greystone.layers.json",
  "/static/materials/layerconfigs/Stone_BrandCo_Erie.layers.json",
  "/static/materials/layerconfigs/Stone_BrandCo_Southbriar.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_QuailGrey.layers.json",
  "/static/materials/layerconfigs/Stone_RS_Trim_IndianaLimestoneGrey.layers.json",
  "/static/materials/layerconfigs/Brick_PS_Farmhouse.layers.json",
  "/static/materials/layerconfigs/Stone_PS_Blanc.layers.json",
  "/static/materials/layerconfigs/Stone_PS_Charcoal.layers.json",
  "/static/materials/layerconfigs/Stone_PS_Harvest.layers.json",
  "/static/materials/layerconfigs/Stone_PS_JacksonCreek.layers.json",
  "/static/materials/layerconfigs/Stone_PS_MoonlitForest.layers.json",
  "/static/materials/layerconfigs/Stone_PS_WhiteOnyx.layers.json",
  "/static/materials/layerconfigs/Brick_US_Magnolia.layers.json",
  "/static/materials/layerconfigs/Brick_US_NatchezTrace.layers.json",
  "/static/materials/layerconfigs/Brick_US_OysterCove.layers.json",
  "/static/materials/layerconfigs/Brick_US_ShadowStone.layers.json",
  "/static/materials/layerconfigs/Brick_US_TimberWood.layers.json",
  "/static/materials/layerconfigs/Stone_DutchQuality_Arizona_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_DS_Arizona.layers.json",
  "/static/materials/layerconfigs/TT_MaritimeGray.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_AuburnHills.layers.json",
  "/static/materials/layerconfigs/Stone_SW_FS_Chardonnay.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_Saltgrass.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_SummerSage.layers.json",
  "/static/materials/layerconfigs/Brick_CBC_ChandlerWhite.layers.json",
  "/static/materials/layerconfigs/Brick_CBC_Hollister.layers.json",
  "/static/materials/layerconfigs/Brick_RedRiver_FlintRanch.layers.json",
  "/static/materials/layerconfigs/Brick_RedRiver_OzarkSmoke.layers.json",
  "/static/materials/layerconfigs/Stone_MetroBrick_AustinCreme.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_Shenandoah.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_SpanishBay.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_WhiteBluff.layers.json",
  "/static/materials/layerconfigs/Brick_Ryder_AntiqueWhite.layers.json",
  "/static/materials/layerconfigs/Brick_Ryder_Casablanca.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_ArcticMist.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_Inverness.layers.json",
  "/static/materials/layerconfigs/PPG_Wood_BlackOak.layers.json",
  "/static/materials/layerconfigs/PPG_Wood_DriftwoodGray.layers.json",
  "/static/materials/layerconfigs/PPG_Wood_Ebony.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_GrayRubble_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Rubble_Gray.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_Trim_Buckskin.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_Trim_Earth.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_Trim_Smoke.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_Trim_Taupe.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_BS_Prescott.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_SS_BlackRiver.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_RT_WhisperWhite.layers.json",
  "/static/materials/layerconfigs/RoofTile_Westlake_BlackCanyon.layers.json",
  "/static/materials/layerconfigs/Stone_Bello_Ledge_Brecknock.layers.json",
  "/static/materials/layerconfigs/Stone_Bello_Ledge_FultonLime.layers.json",
  "/static/materials/layerconfigs/Stone_Bello_Ledge_Greenwood.layers.json",
  "/static/materials/layerconfigs/Stone_Bello_Ledge_Pequea.layers.json",
  "/static/materials/layerconfigs/Stone_Bello_FS_Hickory.layers.json",
  "/static/materials/layerconfigs/Brick_TexasStone_DarkGrayLuxbrick.layers.json",
  "/static/materials/layerconfigs/Brick_TexasStone_OldTownLux.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_GlacierWhite.layers.json",
  "/static/materials/layerconfigs/Brick_Belden_BlackDiamondVelour.layers.json",
  "/static/materials/layerconfigs/Brick_Belden_GraphiteVelour.layers.json",
  "/static/materials/layerconfigs/Brick_Spaulding_YankeeHill.layers.json",
  "/static/materials/layerconfigs/Brick_GS_Graysburg.layers.json",
  "/static/materials/layerconfigs/Brick_GS_MorningSmoke.layers.json",
  "/static/materials/layerconfigs/Brick_GS_OldEnglishTutor.layers.json",
  "/static/materials/layerconfigs/GAF_Barkwood.layers.json",
  "/static/materials/layerconfigs/GAF_MissionBrown.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Buckeye.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Carolina.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Dakota.layers.json",
  "/static/materials/layerconfigs/Stone_SW_GreyDrift.layers.json",
  "/static/materials/layerconfigs/Stone_SW_PASierra.layers.json",
  "/static/materials/layerconfigs/Stone_SW_SanFrancisco.layers.json",
  "/static/materials/layerconfigs/Stone_StoneWorks_Buckeye_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_StoneWorks_Carolina_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_StoneWorks_Dakota_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_StoneWorks_GreyDrift_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_StoneWorks_PASierra_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_StoneWorks_SanFrancisco_Trim.layers.json",
  "/static/materials/layerconfigs/Brick_GS_ModenaPaver.layers.json",
  "/static/materials/layerconfigs/Stone_Ecostone_Moraine_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Ecostone_Moraine.layers.json",
  "/static/materials/layerconfigs/Stone_Ecostone_WhiteWashed_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Ecostone_WhiteWashed.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_Andante_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_FL_Andante.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_ChapelHill_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_Ironside_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_TB_Ironside.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_Nantucket_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_PlyGem_Charcoal_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_PlyGem_Hampton_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_PlyGem_Hampton.layers.json",
  "/static/materials/layerconfigs/Stone_PlyGem_Trim_Lime.layers.json",
  "/static/materials/layerconfigs/Stone_PlyGem_Mystic_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_PlyGem_Mystic.layers.json",
  "/static/materials/layerconfigs/Stone_PlyGem_Oswego_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_PlyGem_Oswego.layers.json",
  "/static/materials/layerconfigs/Stone_PlyGem_SandyCreek_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_PlyGem_CasL_SandyCreek.layers.json",
  "/static/materials/layerconfigs/Wood_Minwax_Stain_Walnut.layers.json",
  "/static/materials/layerconfigs/Wood_Minwax_Stain_Walnut_V.layers.json",
  "/static/materials/layerconfigs/Patio_Irwin_PABlueFlagstone.layers.json",
  "/static/materials/layerconfigs/Brick_GS_Winterhaven.layers.json",
  "/static/materials/layerconfigs/Brick_US_Alamo.layers.json",
  "/static/materials/layerconfigs/Brick_US_AspenChase.layers.json",
  "/static/materials/layerconfigs/Brick_US_Belhaven.layers.json",
  "/static/materials/layerconfigs/Brick_US_BelleMeade.layers.json",
  "/static/materials/layerconfigs/Brick_US_MtRushmore.layers.json",
  "/static/materials/layerconfigs/Brick_US_Newcastle.layers.json",
  "/static/materials/layerconfigs/Brick_US_NorthHighland.layers.json",
  "/static/materials/layerconfigs/Brick_US_OldOverton.layers.json",
  "/static/materials/layerconfigs/Brick_US_StLorain.layers.json",
  "/static/materials/layerconfigs/Stone_BC_SpanishWheat_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_BC_SpanishWheat.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Coastal_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_GrayStainless_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Kentucky_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_NorrisGray_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Texas_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Tulsa_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_DutchQuality_GreatLakes_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_Lime_GreatLakes.layers.json",
  "/static/materials/layerconfigs/Stone_DutchQuality_OakBlend_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_OakBlend.layers.json",
  "/static/materials/layerconfigs/Stone_DutchQuality_OhioTan_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_Lime_OhioTan.layers.json",
  "/static/materials/layerconfigs/Stone_DutchQuality_RA_Greystone_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_RA_Greystone.layers.json",
  "/static/materials/layerconfigs/Stone_DutchQuality_RA_Trailhead_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_RA_Trailhead.layers.json",
  "/static/materials/layerconfigs/Stone_DutchQuality_RA_WinterPoint_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_RA_WinterPoint.layers.json",
  "/static/materials/layerconfigs/Stone_MES_SEL_GainesboroGrey_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_MES_SEL_GainesboroGrey.layers.json",
  "/static/materials/layerconfigs/Stone_MES_SEL_GreyBlend_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_MES_SEL_GreyBlend.layers.json",
  "/static/materials/layerconfigs/Stone_MES_SEL_WestShore_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_MES_SEL_WestShore.layers.json",
  "/static/materials/layerconfigs/Stone_MES_SS_Ash_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_MES_SS_Ash.layers.json",
  "/static/materials/layerconfigs/Stone_MES_WL_Ash_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_MES_WL_Ash.layers.json",
  "/static/materials/layerconfigs/Wood_Minwax_Stain_Jacobean_V.layers.json",
  "/static/materials/layerconfigs/Wood_Minwax_Stain_Jacobean.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Ledge_Kentucky.layers.json",
  "/static/materials/layerconfigs/IKO_CornerstoneWW.layers.json",
  "/static/materials/layerconfigs/IKO_GraniteBlack.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_Ashland_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_TB_Ashland.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_BanffSprings_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_CS_BanffSprings.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_Boardwalk_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_CS_Boardwalk.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_ChalkDust_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_TB_ChalkDust.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_Latigo_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_TB_Latigo.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_Montecito_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_CS_Montecito.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_SilverLining_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_SS_SilverLining.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_WhiteBark_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_WhiteBark.layers.json",
  "/static/materials/layerconfigs/Brick_Harristone_Midnight.layers.json",
  "/static/materials/layerconfigs/Brick_HB_Avondale.layers.json",
  "/static/materials/layerconfigs/Brick_Spaulding_Onslow.layers.json",
  "/static/materials/layerconfigs/CT_Patriot_Sablewood.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_DryStack_WinterPoint_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_DS_WinterPoint.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_Weatherledge_CoalCrest_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_WL_CoalCrest.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_Weatherledge_Elkwood_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_WL_Elkwood.layers.json",
  "/static/materials/layerconfigs/Stone_Harristone_Divino_Huntington_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Harristone_Divino_Huntington.layers.json",
  "/static/materials/layerconfigs/Stone_Harristone_Divino_SilverStrand_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Harristone_Divino_SilverStrand.layers.json",
  "/static/materials/layerconfigs/Stone_Harristone_Drystone_Highland_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Harristone_Drystone_Highland.layers.json",
  "/static/materials/layerconfigs/Stone_Harristone_Drystone_Kingstown_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Harristone_Drystone_Kingstown.layers.json",
  "/static/materials/layerconfigs/Stone_Harristone_Drystone_Slate_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Harristone_Drystone_Slate.layers.json",
  "/static/materials/layerconfigs/Stone_Harristone_Drystone_Stirling_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Harristone_Drystone_Stirling.layers.json",
  "/static/materials/layerconfigs/Stone_Harristone_Leuders_FlintHills_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Harristone_Leuders_FlintHills.layers.json",
  "/static/materials/layerconfigs/Stone_Harristone_Uintah_Midnight_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Harristone_Uintah_Midnight.layers.json",
  "/static/materials/layerconfigs/Stone_Harristone_Uintah_RockyCliff_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Harristone_Uintah_RockyCliff.layers.json",
  "/static/materials/layerconfigs/Stone_HarristoneUintah_Midnight_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_StoneCraft_Chardonnay_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Stonecraft_Hamilton_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Stonecraft_Hamilton.layers.json",
  "/static/materials/layerconfigs/Stone_Harristone_Divino_WhiteSand_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Harristone_Divino_WhiteSand.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_Limestone_ColumbusBlend_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_Lime_ColumbusBlend.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_Limestone_Elkwood_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_Lime_Elkwood.layers.json",
  "/static/materials/layerconfigs/Stone_MES_Cob_GreyBlend_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_MES_Cob_GreyBlend.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_KoryakRidge_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_SS_KoryakRidge.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_NordicPeak_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_CS_NordicPeak.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_Weatherledge_WinterPoint_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_WL_WinterPoint.layers.json",
  "/static/materials/layerconfigs/Stone_StoneCraft_Bucktown_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_StoneCraft_Bucktown.layers.json",
  "/static/materials/layerconfigs/Stone_StoneCraft_Pennsylvania_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_StoneCraft_Pennsylvania.layers.json",
  "/static/materials/layerconfigs/Vinyl_Duradek_SupremeSonomaChip.layers.json",
  "/static/materials/layerconfigs/Brick_Columbus_MagnoliaBay.layers.json",
  "/static/materials/layerconfigs/Brick_Columbus_Weracoba2.layers.json",
  "/static/materials/layerconfigs/GAF_AppalachianSky.layers.json",
  "/static/materials/layerconfigs/GAF_Shakewood.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Pennsylvania_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Ledge_Pennsylvania.layers.json",
  "/static/materials/layerconfigs/Stone_Horizon_Sedona_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Horizon_Sedona.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_BlackRiver_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_BlackRiver.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_BrownsValley_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Elkmont_BrownsValley.layers.json",
  "/static/materials/layerconfigs/Wood_RMFP_WesternRedCedar.layers.json",
  "/static/materials/layerconfigs/Metal_JetMetals_Drexlume.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_Arizona_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_Arizona.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_Ashen_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_Ashen.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_NaturalBlend_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_NaturalBlend.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_Sienna_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_Sienna.layers.json",
  "/static/materials/layerconfigs/Wood_ChamClad_Charwood.layers.json",
  "/static/materials/layerconfigs/Wood_DCM_Cedar.layers.json",
  "/static/materials/layerconfigs/Wood_WD_Beachwood.layers.json",
  "/static/materials/layerconfigs/Wood_WD_Black.layers.json",
  "/static/materials/layerconfigs/Wood_WD_CarbonOak.layers.json",
  "/static/materials/layerconfigs/Wood_WD_MediumOak.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_GrandBanks_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_LS_GrandBanks.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_Hartford_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_TB_Hartford.layers.json",
  "/static/materials/layerconfigs/Stone_PS_MoonlitForest_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_QR_BermudaSand_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_QR_BermudaSand.layers.json",
  "/static/materials/layerconfigs/Stone_QR_CottageWhite_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_QR_CottageWhite.layers.json",
  "/static/materials/layerconfigs/Stone_QR_Glacier_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_QR_Glacier.layers.json",
  "/static/materials/layerconfigs/Stone_QR_Graphite_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_QR_Graphite.layers.json",
  "/static/materials/layerconfigs/Stone_QR_LakeshoreLinen_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_QR_LakeshoreLinen.layers.json",
  "/static/materials/layerconfigs/Stone_QR_Midnight_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_QR_Midnight.layers.json",
  "/static/materials/layerconfigs/Stone_QR_Onyx_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_QR_Onyx.layers.json",
  "/static/materials/layerconfigs/Stone_QR_Slate_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_QR_Slate.layers.json",
  "/static/materials/layerconfigs/Stone_QR_Storm_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_QR_Storm.layers.json",
  "/static/materials/layerconfigs/Stone_QR_Summit_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_QR_Summit.layers.json",
  "/static/materials/layerconfigs/Pella_Wood_Mahogany_V.layers.json",
  "/static/materials/layerconfigs/Pella_Wood_Mahogany.layers.json",
  "/static/materials/layerconfigs/Pella_Wood_Pecan_V.layers.json",
  "/static/materials/layerconfigs/Pella_Wood_Pecan.layers.json",
  "/static/materials/layerconfigs/Stone_QR_SmokeyGray_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_QR_SmokeyGray.layers.json",
  "/static/materials/layerconfigs/Brick_Binsa_Monroe.layers.json",
  "/static/materials/layerconfigs/Brick_Binsa_Smokey.layers.json",
  "/static/materials/layerconfigs/Brick_Mer_FireOak.layers.json",
  "/static/materials/layerconfigs/Brick_Mer_WhiteHillstone.layers.json",
  "/static/materials/layerconfigs/Brick_Mer_WhiteRiverRock.layers.json",
  "/static/materials/layerconfigs/Stone_RM_AspenBlendChopped_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_RM_Sawn_AspenBlendChopped.layers.json",
  "/static/materials/layerconfigs/Stone_RM_CountryFrenchChopped_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_RM_Sawn_CountryFrenchChopped.layers.json",
  "/static/materials/layerconfigs/Wood_Minwax_Stain_DarkWalnut_V.layers.json",
  "/static/materials/layerconfigs/Wood_Minwax_Stain_DarkWalnut.layers.json",
  "/static/materials/layerconfigs/Wood_Minwax_Stain_TrueBlack_V.layers.json",
  "/static/materials/layerconfigs/Wood_Minwax_Stain_TrueBlack.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3023_Flagstone_V.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3023_Flagstone.layers.json",
  "/static/materials/layerconfigs/IKO_SummitGrey.layers.json",
  "/static/materials/layerconfigs/Brick_US_Twilight.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_GrayVillage_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Ledge_GrayVillage.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Trim_Limestone.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Limestone.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3039_Tobacco_V.layers.json",
  "/static/materials/layerconfigs/Wood_SW_Stain_3039_Tobacco.layers.json",
  "/static/materials/layerconfigs/Wood_ChamClad_ChaiCedar.layers.json",
  "/static/materials/layerconfigs/Brick_Tri_ShadowRidge.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_Prestige_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_Prestige.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Antique_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_SS_Antique.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Buffalo_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_SS_Buffalo.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Chalk_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_SS_Chalk.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Chardonnay_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_SS_Chardonnay.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_DarkGranite_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_SS_DarkGranite.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_DirtyChalk_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Hackett_DirtyChalk.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Granite_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Granite.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_GraniteGJ_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_RC_GraniteGJ.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Greenscapes_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_SS_Greenscapes.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_LightGranite_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_SS_LightGranite.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_LightOzark_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_RC_LightOzark.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_LightOzarkGJ_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_RC_LightOzarkGJ.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Midnight_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_SS_Midnight.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Montana_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_SS_Montana.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_MorningHaze_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_SS_MorningHaze.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_OldCedarCreek_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_SS_OldCedarCreek.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Ozark_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Hackett_Ozark.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Pennsylvania_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_SS_Pennsylvania.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Sandstorm_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_SS_Sandstorm.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_SilveradoGJ_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_RC_SilveradoGJ.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Snow_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_RC_Snow.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_SS_Granite_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_SS_Granite.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_SS_Ozark_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_SS_Ozark.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Suede_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_RC_Suede.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Texas_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_SS_Texas.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Trinity_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Hackett_Trinity.layers.json",
  "/static/materials/layerconfigs/Tile_DanyaBasin.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_QuailGrey_Trim.layers.json",
  "/static/materials/layerconfigs/Stone_RM_LuedersCharcoal_Trim.layers.json",
  "/static/materials/layerconfigs/Brick_GlenGery_Americano.layers.json",
  "/static/materials/layerconfigs/Brick_GlenGery_AnthraciteSmooth.layers.json",
  "/static/materials/layerconfigs/Brick_GlenGery_AspenWhite.layers.json",
  "/static/materials/layerconfigs/Brick_GlenGery_BaxterBrownSmooth.layers.json",
  "/static/materials/layerconfigs/Brick_GlenGery_ClassicCreamSmooth.layers.json",
  "/static/materials/layerconfigs/Brick_GlenGery_RusticGrayWaterstruck.layers.json",
  "/static/materials/layerconfigs/Brick_GS_EnglishPub.layers.json",
  "/static/materials/layerconfigs/Brick_GS_Ironworks.layers.json",
  "/static/materials/layerconfigs/Brick_GS_Peppermill.layers.json",
  "/static/materials/layerconfigs/Stone_BC_PB_DantesPeak.layers.json",
  "/static/materials/layerconfigs/Stone_BC_Jasper.layers.json",
  "/static/materials/layerconfigs/Stone_BC_Loveland.layers.json",
  "/static/materials/layerconfigs/Stone_BC_Stonehenge.layers.json",
  "/static/materials/layerconfigs/Stone_Cultured_SL_BucksCounty.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_CCS_Seashell.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_CRidge_Orchard.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_EL_Zinc.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_RC_FallingSpring.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_PF_Onyx.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_EL_SeaCliff.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_EL_Sidewalk.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_RC_CasaBlanca.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_RC_LoireValley.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_RC_VineyardTrail.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_Lime_Buff.layers.json",
  "/static/materials/layerconfigs/Brick_GS_ColonyPointe.layers.json",
  "/static/materials/layerconfigs/Brick_GS_CumberlandTudor.layers.json",
  "/static/materials/layerconfigs/Stone_PlyGem_SL_Buckingham.layers.json",
  "/static/materials/layerconfigs/Stone_PlyGem_SL_Hampton.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Ledge_Kentucky.layers.json",
  "/static/materials/layerconfigs/VinylStone_NaturalSlateGray.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Granite.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Granite.layers.json",
  "/static/materials/layerconfigs/Stone_CDS_Matera.layers.json",
  "/static/materials/layerconfigs/Stone_CDS_Terracina.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_GrayStainless.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Limestone.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_NorrisGray.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Texas.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_GrayStainless.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Limestone.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_NorrisGray.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Texas.layers.json",
  "/static/materials/layerconfigs/Stone_Cultured_Chardonnay.layers.json",
  "/static/materials/layerconfigs/Stone_Cultured_Chardonnay.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_Ashen.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_Pennsylvania.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_Prestige.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_Sienna.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_Pennsylvania.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_Sienna.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_OakBlend.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_Sagewood.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_Sienna.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_OakBlend.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_NaturalBlend.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_Pennsylvania.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_Prestige.layers.json",
  "/static/materials/layerconfigs/Stone_DQ_QuailGrey.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_Monument.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_RC_Moonlight.layers.json",
  "/static/materials/layerconfigs/Stone_MGBS_Walnut.layers.json",
  "/static/materials/layerconfigs/Stone_MGBS_Walnut.layers.json",
  "/static/materials/layerconfigs/Stone_MV_Appalachian.layers.json",
  "/static/materials/layerconfigs/Stone_MV_Tuscany.layers.json",
  "/static/materials/layerconfigs/Stone_PlyGem_Mystic.layers.json",
  "/static/materials/layerconfigs/Stone_PS_Charcoal.layers.json",
  "/static/materials/layerconfigs/Stone_PS_JacksonCreek.layers.json",
  "/static/materials/layerconfigs/Stone_PS_PortlandMist.layers.json",
  "/static/materials/layerconfigs/Stone_PS_WhiteOnyx.layers.json",
  "/static/materials/layerconfigs/Stone_Prostone_Sawgrass.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_Flintridge.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_Frost.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_Slate.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_Summit.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Chisel_Cream.layers.json",
  "/static/materials/layerconfigs/Stone_SW_CustomEpcon.layers.json",
  "/static/materials/layerconfigs/Stone_Env_CS_Kentucky.layers.json",
  "/static/materials/layerconfigs/Stone_Env_CS_Texas.layers.json",
  "/static/materials/layerconfigs/Stone_Env_Dakota.layers.json",
  "/static/materials/layerconfigs/Stone_Env_PASierra.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Carolina.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Dakota.layers.json",
  "/static/materials/layerconfigs/Stone_SW_GreyDrift.layers.json",
  "/static/materials/layerconfigs/Stone_SW_PASierra.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Dakota.layers.json",
  "/static/materials/layerconfigs/Stone_SW_CustomEpcon.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Rosa.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Grezzo_SabbieNere.layers.json",
  "/static/materials/layerconfigs/Stone_SW_CustomEpcon.layers.json",
  "/static/materials/layerconfigs/Stone_SW_CustomINDakota.layers.json",
  "/static/materials/layerconfigs/Stone_SW_CustomEpcon.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Ledge_Breakwater.layers.json",
  "/static/materials/layerconfigs/Stone_SW_PSL_IronSmoke.layers.json",
  "/static/materials/layerconfigs/Stone_SW_GreyDrift.layers.json",
  "/static/materials/layerconfigs/Stone_SW_CustomEpcon.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Tivoli_Cream.layers.json",
  "/static/materials/layerconfigs/Stone_SW_CustomEpcon.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_ML_GreyDrift.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_3_5L_Chalk.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_3_5L_DarkGranite.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Trinity.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_CS_MorningHaze.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Midnight.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_TexasCreme.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Buffalo.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_CustomGranite.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Gray.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_ECobble_Granite.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_ECobble_LightOzark.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_ChalkOG.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_OzarkArkansas.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Natural.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_FS_Arkansas.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_FS_OldCedarCreek.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_FS_Chestnut.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_ValleyBlend.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Arkansas.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_NaturalDrystack.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_OldCedarCreek.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_MountainBreezeGJ.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Hackett_LightGranite.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Chestnut.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Hackett_Chalk.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Cherokee.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Texas.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_L_Granite.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_L_Chardonnay.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_KansasCream.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Lime_BrownArkansas.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_KansasCreamGJ.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_ChalkLightOzark.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_CustomOzark.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Desert.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_BrownArkansas.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_MR_LightGranite.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_CedarCreek.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_MR_Ozark.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Chalk.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_MWQF_Slate.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_MWQF_MorningHaze.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Sahara.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_MWQF_Sandstorm.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_HarvestGold.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_QF_Granite.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_QF_Natural.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_QF_Arkansas.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_DirtyChalk.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_QF_Ozark.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_BurntUmber.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_CaramelMountain.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Arizona.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Winchester.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_ReverseTexasStone.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_STL_Chalk.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Sienna.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_BlackForest.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Dusk.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Chalk.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_BrickRed.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_TB_Granite.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_TB_LightOzark.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Schoolhouse.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Slate.layers.json",
  "/static/materials/layerconfigs/Stone_SCM_Antique.layers.json",
  "/static/materials/layerconfigs/Stone_SW_FS_GreyDrift.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_StoneLake.layers.json",
  "/static/materials/layerconfigs/Brick_RedRiver_Madrono.layers.json",
  "/static/materials/layerconfigs/Brick_US_WeatheredWhite.layers.json",
  "/static/materials/layerconfigs/Stone_SW_AutumnBlend.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Buff.layers.json",
  "/static/materials/layerconfigs/Stone_SW_CB_Carillion.layers.json",
  "/static/materials/layerconfigs/Stone_SW_CassisModena.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Charcoal.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Chocolate.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Claystone.layers.json",
  "/static/materials/layerconfigs/Stone_SW_CB_GreyDrift.layers.json",
  "/static/materials/layerconfigs/Stone_SW_CB_Lakeshore.layers.json",
  "/static/materials/layerconfigs/Stone_SW_MiamiPearl.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Moline.layers.json",
  "/static/materials/layerconfigs/Stone_SW_CB_Slate.layers.json",
  "/static/materials/layerconfigs/Stone_SW_CS_Dakota.layers.json",
  "/static/materials/layerconfigs/Stone_SW_BullRun.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Nantucket.layers.json",
  "/static/materials/layerconfigs/Stone_SW_LindenWood.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Principe.layers.json",
  "/static/materials/layerconfigs/Stone_SW_SanDomino.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Hackett_AndesSummit.layers.json",
  "/static/materials/layerconfigs/Stone_SW_BlackOak.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Sandstone.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Ledge_Appalachian.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Aspen.layers.json",
  "/static/materials/layerconfigs/Stone_SW_BucksCounty.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Champagne.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Grey.layers.json",
  "/static/materials/layerconfigs/Stone_SW_MiamiPearl.layers.json",
  "/static/materials/layerconfigs/Stone_SW_BlackRundle.layers.json",
  "/static/materials/layerconfigs/Stone_SW_CedarMesa.layers.json",
  "/static/materials/layerconfigs/Stone_SW_CoolRiver.layers.json",
  "/static/materials/layerconfigs/Stone_SW_EaglesNook.layers.json",
  "/static/materials/layerconfigs/Stone_SW_MiamiPearl.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Monterey.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Saluzzo.layers.json",
  "/static/materials/layerconfigs/Stone_SW_VillaMadero.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Eclipse.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Mystic.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Stardust.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Osceola.layers.json",
  "/static/materials/layerconfigs/Stone_SW_BucksCounty.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Chestnut.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Cortona.layers.json",
  "/static/materials/layerconfigs/Stone_SW_MesaVerde.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Slate.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Tivoli_Carillion.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Taupe.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Tivoli_GunMetal.layers.json",
  "/static/materials/layerconfigs/Stone_SW_NickelCreek.layers.json",
  "/static/materials/layerconfigs/Stone_SW_WillowPeak.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Mist.layers.json",
  "/static/materials/layerconfigs/Stone_SW_TL_AndesSummit.layers.json",
  "/static/materials/layerconfigs/Stone_SW_EnglishBay.layers.json",
  "/static/materials/layerconfigs/Stone_SW_TL_LindenWood.layers.json",
  "/static/materials/layerconfigs/Stone_SW_CessnaTan.layers.json",
  "/static/materials/layerconfigs/Stone_SW_NewEngland.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Northwoods.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Silvermine.layers.json",
  "/static/materials/layerconfigs/Stone_SW_WE_Slate.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Chisel_Taupe.layers.json",
  "/static/materials/layerconfigs/Stone_SW_DesertSunset.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Luxor_Cream.layers.json",
  "/static/materials/layerconfigs/Stone_SW_PB_MiamiPearl.layers.json",
  "/static/materials/layerconfigs/Stone_SW_TB_MiamiPearl.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Moline.layers.json",
  "/static/materials/layerconfigs/Stone_SW_TB_Slate.layers.json",
  "/static/materials/layerconfigs/Stone_SW_TB_Lakeshore.layers.json",
  "/static/materials/layerconfigs/Stone_SW_TB_GreyDrift.layers.json",
  "/static/materials/layerconfigs/Stone_SW_Clove.layers.json",
  "/static/materials/layerconfigs/Stone_SW_CassisModena.layers.json",
  "/static/materials/layerconfigs/Stone_SW_TB_Buff.layers.json",
  "/static/materials/layerconfigs/Stone_SW_TB_AutumnBlend.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_Redmont.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_SpanishFort.layers.json",
  "/static/materials/layerconfigs/Brick_Columbus_Charleston.layers.json",
  "/static/materials/layerconfigs/Brick_Columbus_Georgetown.layers.json",
  "/static/materials/layerconfigs/Brick_Columbus_OldBailey.layers.json",
  "/static/materials/layerconfigs/Brick_Columbus_Ortega.layers.json",
  "/static/materials/layerconfigs/Brick_Columbus_StoneChase.layers.json",
  "/static/materials/layerconfigs/Brick_Tri_KnobHill.layers.json",
  "/static/materials/layerconfigs/Brick_US_Laredo.layers.json",
  "/static/materials/layerconfigs/CT_Landmark_TerraCotta.layers.json",
  "/static/materials/layerconfigs/GAF_AgedChestnut.layers.json",
  "/static/materials/layerconfigs/GAF_Birchwood.layers.json",
  "/static/materials/layerconfigs/GAF_ChestnutValley.layers.json",
  "/static/materials/layerconfigs/GAF_Cliffside.layers.json",
  "/static/materials/layerconfigs/GAF_CoastalSlate.layers.json",
  "/static/materials/layerconfigs/GAF_CopperCanyon.layers.json",
  "/static/materials/layerconfigs/GAF_GoldenAmber.layers.json",
  "/static/materials/layerconfigs/GAF_Hickory.layers.json",
  "/static/materials/layerconfigs/GAF_HunterGreen.layers.json",
  "/static/materials/layerconfigs/GAF_MidnightMesa.layers.json",
  "/static/materials/layerconfigs/GAF_Sagewood.layers.json",
  "/static/materials/layerconfigs/GAF_Sandalwood.layers.json",
  "/static/materials/layerconfigs/GAF_SierraSand.layers.json",
  "/static/materials/layerconfigs/GAF_Slate.layers.json",
  "/static/materials/layerconfigs/GAF_StoneGray.layers.json",
  "/static/materials/layerconfigs/IKO_AtlanticBlue.layers.json",
  "/static/materials/layerconfigs/IKO_Biscayne.layers.json",
  "/static/materials/layerconfigs/IKO_Brownstone.layers.json",
  "/static/materials/layerconfigs/IKO_DriftShake.layers.json",
  "/static/materials/layerconfigs/IKO_EmeraldGreen.layers.json",
  "/static/materials/layerconfigs/IKO_FrostoneGray.layers.json",
  "/static/materials/layerconfigs/IKO_Glacier.layers.json",
  "/static/materials/layerconfigs/IKO_MonacoRed.layers.json",
  "/static/materials/layerconfigs/IKO_OldeStyleWeatherwood.layers.json",
  "/static/materials/layerconfigs/IKO_SentinelSlate.layers.json",
  "/static/materials/layerconfigs/IKO_ShadowBrown.layers.json",
  "/static/materials/layerconfigs/Stone_CDS_Blend_Cremona.layers.json",
  "/static/materials/layerconfigs/Stone_CDS_QL_Dente.layers.json",
  "/static/materials/layerconfigs/Stone_CDS_VL_Ardesia.layers.json",
  "/static/materials/layerconfigs/Stone_CDS_Volterra_Genoa.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_BrookS_Shoreline.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_CReef_PearlWhite.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_CReef_Sanibel.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_LS_York.layers.json",
  "/static/materials/layerconfigs/Stone_FDL_CharcoalCountry.layers.json",
  "/static/materials/layerconfigs/Stone_FDL_GraphiteFalls.layers.json",
  "/static/materials/layerconfigs/Stone_Halquist_Mosaic_AshfordBlend.layers.json",
  "/static/materials/layerconfigs/Stone_Halquist_Mosaic_KohlerBuff.layers.json",
  "/static/materials/layerconfigs/Stone_Halquist_Mosaic_KohlerFullColor.layers.json",
  "/static/materials/layerconfigs/Stone_Halquist_Ledge_BasswoodBuff.layers.json",
  "/static/materials/layerconfigs/Stone_Halquist_Ledge_BrookfieldBuff.layers.json",
  "/static/materials/layerconfigs/Stone_Lurveys_GraphiteFalls.layers.json",
  "/static/materials/layerconfigs/Stone_PS_FS_Acadia.layers.json",
  "/static/materials/layerconfigs/Stone_PS_MD_WhiteOnyx.layers.json",
  "/static/materials/layerconfigs/Stone_PS_WL_PortlandDusk.layers.json",
  "/static/materials/layerconfigs/Stone_PS_WL_Winona.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_Ledge_Mystic.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_Ledge_Oxford.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_Ledge_Southbriar.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_Niagara.layers.json",
  "/static/materials/layerconfigs/Tamko_BlackWalnut.layers.json",
  "/static/materials/layerconfigs/Tamko_RusticBrown.layers.json",
  "/static/materials/layerconfigs/Wood_Minwax_Stain_Ebony2718.layers.json",
  "/static/materials/layerconfigs/Wood_Minwax_Stain_Forrester421.layers.json",
  "/static/materials/layerconfigs/Wood_Minwax_Stain_Navy471.layers.json",
  "/static/materials/layerconfigs/Wood_Minwax_Stain_TidalWood415.layers.json",
  "/static/materials/layerconfigs/Wood_Minwax_Stain_Willowbend431.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Ashlar_BucksCounty.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Ashlar_OdessaFalls.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Ashlar_Pennsylvania.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Biltmore_Pennsylvania.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Biltmore_Smoke.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Biltmore_Texas.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_BrickS_Lexington.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_BrickS_Midnight.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_BrickS_Mist.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_BrookS_Cream.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_BrookS_Heather.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_BrookS_Rocky.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_CathedralS_Alpine.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_CathedralS_Plain.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_CathedralS_SageValley.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_CB_BucksCounty.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_CB_Pennsylvania.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_CB_Suede.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_CC_BucksCounty.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_CC_California.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_CC_Gray.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_CC_Pennsylvania.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_CC_Suede.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_CF_Arizona.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_CF_Brown.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_CF_Kentucky.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_CF_Louisville.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_CF_MountainRundle.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_CF_Pennsylvania.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_CF_Suede.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_CL_BrownsValley.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_CL_SouthernWheat.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Design_Austin.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Design_Chardonnay.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Design_Coastal.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Design_Kentucky.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Design_MesaValley.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Design_MountainRundle.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Elkmont_Kentucky.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Foundation_Crimson.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Foundation_Plain.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_FS_Plain.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_FS_Kentucky.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Georgetown_Smoke.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Georgetown_Kentucky.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Hackett_Austin.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Hackett_English.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Ledge_Louisville.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Ledge_Brown.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Ledge_BucksCounty.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Mesa_Appalachian.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_ML_Austin.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_ML_BucksCounty.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_ML_Kentucky.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_ML_Oxford.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_OLS_BrownsValley.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_OLS_Millwood.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_OLS_Texas.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_OLS_Tulsa.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_PV_Summit.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_PV_Kentucky.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_PV_Pennsylvania.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_QS_BellHarbor.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_RR_BrownsValley.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_RR_DesertRust.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_RR_ValleyBrook.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Rubble_BucksCounty.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Rubble_Suede.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Rubble_Pennsylvania.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Rubble_Plain.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Rubble_Kentucky.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Rustic_Gray.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Rustic_Pennsylvania.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Rustic_Kentucky.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Rustic_Arizona.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Rustic_Brown.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_SF_NewEngland.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_SF_Pennsylvania.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_SF_Texas.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_SL_Catalina.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_SL_Suede.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Stack_Kentucky.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Stack_Chardonnay.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Stack_Arizona.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Stack_Pennsylvania.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Stack_BucksCounty.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_Topeka_Santos.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_WE_Brown.layers.json",
  "/static/materials/layerconfigs/Stone_Centurion_WE_Kentucky.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_BS_Bodega.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_BS_Mineret.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_CA_Carmela.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_CA_Bautista.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_CCS_Cannonade.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_CCS_Madrona.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_CCS_Oyster.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_CRidge_Catania.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_CRubble_Cognac.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_CRubble_Bella.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_CRubble_Millstream.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_CRubble_Polermo.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_CS_Barley.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_CS_Cambria.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_CS_Lantana.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_CS_Manzanita.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_CS_Mesquite.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_EL_Cottonwood.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_EL_Glacier.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_EL_Linen.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_FL_Meseta.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_FL_Padova.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_FL_RanchersRidge.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_FL_Veneto.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_LB_Farola.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_LB_Hollin.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_LB_Lilia.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_LB_Talavera.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_LC_BeachPebble.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_LC_Birch.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_LC_OceanFloor.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_LC_Sage.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_LC_Whitecap.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_LS_NewHaven.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_LS_SanMarino.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_LS_Shilo.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_Marquee_DoveTail.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_Marquee_Sanderling.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_ML_Asheville.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_ML_Charleston.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_ML_Durango.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_ML_Lexington.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_ML_Yukon.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_MLP_BowValley.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_MLP_Pioneer.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_MLP_Russet.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_MLP_Silverton.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_MLP_WhiskeyCreek.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_RC_RanchersRidge.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_RC_Wheatfield.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_RL_Cascade.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_RL_Sawtooth.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_RL_Sequoia.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_RR_Colorado.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_RR_RioGrande.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_RR_Yakima.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_RT_GraniteSpire.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_SR_Bronze.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_SR_Chesapeake.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_SR_CrescentPeak.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_SR_Somerset.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_SR_Teton.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_SR_Willow.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_SS_Alderwood.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_SS_Castaway.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_SS_DarkRundle.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_SS_Daybreak.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_SS_DryCreek.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_SS_SlateGray.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_TB_Riverbed.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_Vantage_Cumulus.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_Vantage_SouthernPeak.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_Vantage_Stormcloud.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_Vantage_WhiteElm.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_Zen_Nickel.layers.json",
  "/static/materials/layerconfigs/Stone_Eldorado_Zen_SoftLight.layers.json",
  "/static/materials/layerconfigs/Stone_PlyGem_CanL_Chardonnay.layers.json",
  "/static/materials/layerconfigs/Stone_PlyGem_CanL_Hampton.layers.json",
  "/static/materials/layerconfigs/Stone_PlyGem_CanL_Niagara.layers.json",
  "/static/materials/layerconfigs/Stone_PlyGem_CanL_MidnightSlate.layers.json",
  "/static/materials/layerconfigs/Stone_PlyGem_CanL_Summit.layers.json",
  "/static/materials/layerconfigs/Stone_PlyGem_CanL_Winfield.layers.json",
  "/static/materials/layerconfigs/Stone_PlyGem_CasL_AlpineMist.layers.json",
  "/static/materials/layerconfigs/Stone_PlyGem_CC_Aberdeen.layers.json",
  "/static/materials/layerconfigs/Stone_PlyGem_CC_Autumn.layers.json",
  "/static/materials/layerconfigs/Stone_PlyGem_CC_Buckingham.layers.json",
  "/static/materials/layerconfigs/Stone_PlyGem_CC_Chardonnay.layers.json",
  "/static/materials/layerconfigs/Stone_PlyGem_CC_Hampton.layers.json",
  "/static/materials/layerconfigs/Stone_PlyGem_CC_PALime.layers.json",
  "/static/materials/layerconfigs/Stone_PlyGem_CC_ShadeMountain.layers.json",
  "/static/materials/layerconfigs/Stone_PlyGem_CC_Winfield.layers.json",
  "/static/materials/layerconfigs/Stone_PlyGem_FS_Autumn.layers.json",
  "/static/materials/layerconfigs/Stone_PlyGem_FS_Buckingham.layers.json",
  "/static/materials/layerconfigs/Stone_PlyGem_FS_Chardonnay.layers.json",
  "/static/materials/layerconfigs/Stone_PlyGem_FS_PALime.layers.json",
  "/static/materials/layerconfigs/Stone_PlyGem_FS_ShadeMountain.layers.json",
  "/static/materials/layerconfigs/Stone_PlyGem_MS_Summit.layers.json",
  "/static/materials/layerconfigs/Stone_PlyGem_SL_Autumn.layers.json",
  "/static/materials/layerconfigs/Stone_PlyGem_SL_Bradford.layers.json",
  "/static/materials/layerconfigs/Stone_PlyGem_SL_Chardonnay.layers.json",
  "/static/materials/layerconfigs/Stone_PlyGem_SL_Shenandoah.layers.json",
  "/static/materials/layerconfigs/Stone_PlyGem_CanL_Mystic.layers.json",
  "/static/materials/layerconfigs/Stone_PlyGem_SL_Niagara.layers.json",
  "/static/materials/layerconfigs/Stone_PlyGem_SL_PALime.layers.json",
  "/static/materials/layerconfigs/Stone_PlyGem_SL_ShadeMountain.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_CC_Olympus.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_CC_Sterling.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_CC_Wellington.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_DS_Catawba.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_DS_Chestnut.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_DS_Huron.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_DS_Shawnee.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_DS_Southport.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_DS_Toccoa.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_DS_Whisperwood.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_EC_Admiral.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_EC_Beech.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_EC_Obsidian.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_EC_Polar.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_FS_Breckenridge.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_FS_OldDominion.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_FS_Pennsylvania.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_FS_Shenandoah.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_FS_Strathmore.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_FS_TopRock.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_Ledge_Brighton.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_Ledge_Santee.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_Ledge_Susquehanna.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_Lime_Buckingham.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_Lime_Harbor.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_Lime_OhioVintage.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_Lime_Vail.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_NC_Alta.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_NC_Fernwood.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_NC_Seaboard.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_NC_Woodbridge.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_PF_Alpine.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_PF_Arctic.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_PF_SageGray.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_RC_CastleRock.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_RC_Denali.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_RC_Yosemite.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_RR_Michigan.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_RR_Mountain.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_TB_Boston.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_TB_Cobblestone.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_TB_Delaware.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_TB_Independence.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_TB_Midnight.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_TB_Yorktown.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_TC_Acadia.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_TC_Graphite.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_TC_Niagara.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_TC_Palisade.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_TC_Rainier.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_TC_Wellington.layers.json",
  "/static/materials/layerconfigs/Stone_ProVia_TC_Yuma.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_CiboloTrail.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_CopperasCove.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_OxfordPlace.layers.json",
  "/static/materials/layerconfigs/Brick_Claymex_UrbanaAntique.layers.json",
  "/static/materials/layerconfigs/Brick_CBC_CommercialAntique.layers.json",
  "/static/materials/layerconfigs/Brick_Master_Chateau.layers.json",
  "/static/materials/layerconfigs/Brick_Master_PortEdwards.layers.json",
  "/static/materials/layerconfigs/Brick_RedRiver_SteelManor.layers.json",
  "/static/materials/layerconfigs/Brick_RedRiver_SummerAsh.layers.json",
  "/static/materials/layerconfigs/Brick_Acme_WhiteBirch.layers.json",
  "/static/materials/layerconfigs/Stone_Legends_EdinburghBlend.layers.json",
  "/static/materials/layerconfigs/Stone_Legends_PoconosBlend.layers.json",
  "/static/materials/layerconfigs/Stone_Legends_WexfordBlend.layers.json",
  "/static/materials/layerconfigs/Stone_Legends_AshlandGray.layers.json",
  "/static/materials/layerconfigs/Stone_Legends_BrazosCanyon.layers.json",
  "/static/materials/layerconfigs/Stone_Legends_Castlebridge.layers.json",
  "/static/materials/layerconfigs/Stone_RM_BlancoLedgestone.layers.json",
  "/static/materials/layerconfigs/Stone_RM_BluebonnetChop.layers.json",
];
